import { render, staticRenderFns } from "./InputOrders.vue?vue&type=template&id=475b9c00&"
import script from "./InputOrders.vue?vue&type=script&lang=js&"
export * from "./InputOrders.vue?vue&type=script&lang=js&"
import style0 from "./InputOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VDataTable,VIcon,VTooltip})
